import t from 'ember-intl/helpers/t';

<template>
  <div class='o-error-page'>
    <div class='o-error-page__wrapper'>
      {{#if @model.errors}}
        {{#each @model.errors as |error|}}
          <div class='o-error-page__status'>{{error.status}}</div>
          <div class='o-error-page__title'>{{error.title}}</div>
          {{error.detail}}
        {{/each}}
      {{else if @model.message}}
        <div class='o-error-page__status'>{{@model.name}}</div>
        <div class='o-error-page__title'>{{@model.message}}</div>
      {{else}}
        <div class='o-error-page__status'>{{t 'error.error_404.status'}}</div>
        <div class='o-error-page__title'>{{t 'error.error_404.title'}}</div>
        {{t 'error.error_404.detail'}}
      {{/if}}
    </div>

    <div class='o-error-page__image'>
      <img
        class='o-error-page__logo'
        src='/assets/images/logo_univseral_music_inverted.svg'
        alt={{t 'sign_in.logo_alt'}}
      />
    </div>
  </div>
</template>
